// Shared CSV export utility - flattens real page data to CSV and triggers download.
// Zero external deps. Works with arrays of objects, single objects, or nested objects.

function flattenValue(v) {
  if (v === null || v === undefined) return '';
  if (typeof v === 'object') {
    try { return JSON.stringify(v); } catch (e) { return String(v); }
  }
  return String(v);
}

function csvEscape(s) {
  const str = flattenValue(s);
  if (/[",\n\r]/.test(str)) {
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
}

// Convert an array of flat objects to CSV using the union of keys as headers.
function rowsToCsv(rows) {
  if (!rows || rows.length === 0) return '';
  const keys = [];
  rows.forEach(r => {
    if (r && typeof r === 'object') {
      Object.keys(r).forEach(k => { if (!keys.includes(k)) keys.push(k); });
    }
  });
  if (keys.length === 0) {
    // array of primitives
    return 'value\n' + rows.map(r => csvEscape(r)).join('\n');
  }
  const header = keys.map(csvEscape).join(',');
  const body = rows.map(r => keys.map(k => csvEscape(r ? r[k] : '')).join(',')).join('\n');
  return header + '\n' + body;
}

// Turn arbitrary page data into an array of rows.
function normalizeToRows(data) {
  if (data === null || data === undefined) return [];
  if (Array.isArray(data)) return data;
  if (typeof data === 'object') {
    // If the object has an obvious array field, prefer the first array of objects found.
    const arrayFields = Object.keys(data).filter(
      k => Array.isArray(data[k]) && data[k].length > 0 && typeof data[k][0] === 'object'
    );
    if (arrayFields.length === 1) return data[arrayFields[0]];
    // Otherwise emit the top-level object as a single key/value table.
    return Object.keys(data).map(k => ({ field: k, value: flattenValue(data[k]) }));
  }
  return [{ value: flattenValue(data) }];
}

export function exportDataToCsv(data, filename) {
  const rows = normalizeToRows(data);
  if (!rows || rows.length === 0) {
    if (typeof window !== 'undefined' && window.alert) window.alert('No data available to export.');
    return false;
  }
  const csv = rowsToCsv(rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = (filename || 'export') + (String(filename || '').endsWith('.csv') ? '' : '.csv');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return true;
}

export default exportDataToCsv;
